import Model from './Model';

export default class Product extends Model {
  initializeFields() {
    this.product_ref = this.data.product_ref;
    this.names = this.prepareNames();
  }

  prepareNames() {
    return this.data.names.split('|').join(', ');
  }
}
